// Helpers compartidos de estatus/prioridad del módulo de Seguimiento de
// Actividades (tickets). Centraliza los textos y las clases de
// ".status-badge" para no duplicar esta lógica entre las pantallas que la
// necesitan (CatSeguimientoActividadesScreen, SeguimientoActividadesCardScreen).

export const obtenerTextoEstado = (estatus) => {
    switch (estatus) {
        case "C": return "CREADO";
        case "P": return "PROCESO";
        case "F": return "FINALIZADO";
        case "A": return "ACEPTADO";
        case "R": return "RECHAZADO";
        case "X": return "REACTIVADO";
        case "M": return "COMENTARIO";
        default: return estatus || "";
    }
};

// Sufijo de la clase ".status-badge--estatus-*" (definida en
// _SA_GestionModales.scss) para cada estatus.
export const obtenerClaseEstado = (estatus) => {
    switch (estatus) {
        case "C": return "creado";
        case "P": return "proceso";
        case "F": return "finalizado";
        case "A": return "aceptado";
        case "R": return "rechazado";
        case "X": return "reactivado";
        default: return "creado";
    }
};

export const obtenerTextoPrioridad = (p) => {
    switch (p) {
        case "A": return "ALTA";
        case "M": return "MEDIA";
        case "B": return "BAJA";
        default: return "";
    }
};

// Sufijo de la clase ".status-badge--prioridad-*" (definida en
// _SA_GestionModales.scss).
export const obtenerClasePrioridad = (p) => {
    switch (p) {
        case "A": return "alta";
        case "M": return "media";
        case "B": return "baja";
        default: return "";
    }
};

// Una vez que el ticket llega a uno de estos estatus ya no se cambia más
// manualmente desde el detalle (el flujo de calificación/reactivación del
// creador es aparte). Exportado porque también se usa para bloquear la
// edición del checklist una vez que el ticket queda en un estatus final.
export const ESTATUS_TERMINALES = ["F", "A", "R"];

// Opciones para cambiar el estatus manualmente desde el detalle del ticket
// (POST SeguimientoAct/CambiarEstatus). Dependen del tipo de sala, no de un
// flujo fijo de estatus: las salas "normales" (tiposala "N") se trabajan
// (Proceso/Finalizado) y las de "autorización" (tiposala "A", ej.
// Confirmación de depósitos) solo se aprueban o rechazan
// (Autorizado/Rechazado). Solo controla qué opciones se muestran en el
// frontend -- el backend valida exactamente la misma regla
// (CandidatosPorTipoSala en SeguimientoActController.cs) porque no hay que
// confiar en lo que mande el cliente. Si se ajusta uno, hay que ajustar
// el otro.
export const obtenerTransicionesDisponibles = (estatusActual, tipoSala) => {
    if (ESTATUS_TERMINALES.includes(estatusActual)) return [];

    const candidatos = tipoSala === "A" ? ["A", "R"] : ["P", "F"];
    return candidatos.filter((c) => c !== estatusActual);
};
